/**
 * Récupère les informations à afficher selon si la délégation de label est activé pour le label courant.
 */
export default function bookingDelegationGetInformations({
  configuration,
  room,
}: {
  room: ReturnType<
    typeof import("../../../normalizers/room/parseResource").default
  >;
  configuration: ReturnType<
    typeof import("../../../normalizers/configuration/parseData").default
  >;
}) {
  const { useBookingDelegation } = configuration.channel.website;
  if (useBookingDelegation) {
    let delegatedChannel: (typeof configuration.channel.website.delegatedChannels)[keyof typeof configuration.channel.website.delegatedChannels];
    for (const [channelId, channel] of Object.entries(
      configuration.channel.website.delegatedChannels
    )) {
      if (channelId === room?.mainChannel?.channelId) {
        delegatedChannel = channel;
        break;
      }
    }
    if (delegatedChannel) {
      return delegatedChannel?.informations ?? null;
    }
  }
  return configuration.channel.informations;
}
